const config = {
  api_server: process.env.VUE_APP_API_SERVER,
  timeoutDuration: 30000,
  pusher_key: process.env.VUE_APP_PUSHER_KEY,
  pusher_cluster: "us3",
};

export { config };
